/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Best1Inputs */

const id_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbaik:`)
};

const ms_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbaik:`)
};

const da_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedst:`)
};

const de_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beste:`)
};

const en_us2_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best:`)
};

const es_es2_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejor:`)
};

const es_mx2_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejor`)
};

const fil_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakamahusay:`)
};

const fr_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleur :`)
};

const it_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migliore:`)
};

const hu_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legjobb:`)
};

const nl_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beste:`)
};

const no_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best:`)
};

const pl_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepsze:`)
};

const pt_br2_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhor:`)
};

const pt_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhor:`)
};

const ro_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cel mai bun:`)
};

const fi_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paras:`)
};

const sv_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bäst:`)
};

const vi_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tốt nhất:`)
};

const tr_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En iyi:`)
};

const cs_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejlepší:`)
};

const bg_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-добро:`)
};

const ru_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лучший:`)
};

const uk_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найкраще:`)
};

const ar_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأفضل:`)
};

const hi_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सर्वश्रेष्ठ:`)
};

const th_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดีที่สุด:`)
};

const ja_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最高：`)
};

const zh_cn2_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最佳：`)
};

const zh_hant1_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最佳：`)
};

const ko_components_performancetable_best1 = /** @type {(inputs: Components_Performancetable_Best1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최고:`)
};

/**
* | output |
* | --- |
* | "Best:" |
*
* @param {Components_Performancetable_Best1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_best1 = /** @type {((inputs?: Components_Performancetable_Best1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Best1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_best1(inputs)
	if (locale === "ms") return ms_components_performancetable_best1(inputs)
	if (locale === "da") return da_components_performancetable_best1(inputs)
	if (locale === "de") return de_components_performancetable_best1(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_best1(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_best1(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_best1(inputs)
	if (locale === "fil") return fil_components_performancetable_best1(inputs)
	if (locale === "fr") return fr_components_performancetable_best1(inputs)
	if (locale === "it") return it_components_performancetable_best1(inputs)
	if (locale === "hu") return hu_components_performancetable_best1(inputs)
	if (locale === "nl") return nl_components_performancetable_best1(inputs)
	if (locale === "no") return no_components_performancetable_best1(inputs)
	if (locale === "pl") return pl_components_performancetable_best1(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_best1(inputs)
	if (locale === "pt") return pt_components_performancetable_best1(inputs)
	if (locale === "ro") return ro_components_performancetable_best1(inputs)
	if (locale === "fi") return fi_components_performancetable_best1(inputs)
	if (locale === "sv") return sv_components_performancetable_best1(inputs)
	if (locale === "vi") return vi_components_performancetable_best1(inputs)
	if (locale === "tr") return tr_components_performancetable_best1(inputs)
	if (locale === "cs") return cs_components_performancetable_best1(inputs)
	if (locale === "bg") return bg_components_performancetable_best1(inputs)
	if (locale === "ru") return ru_components_performancetable_best1(inputs)
	if (locale === "uk") return uk_components_performancetable_best1(inputs)
	if (locale === "ar") return ar_components_performancetable_best1(inputs)
	if (locale === "hi") return hi_components_performancetable_best1(inputs)
	if (locale === "th") return th_components_performancetable_best1(inputs)
	if (locale === "ja") return ja_components_performancetable_best1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_best1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_best1(inputs)
	return ko_components_performancetable_best1(inputs)
});
export { components_performancetable_best1 as "components.performanceTable.best" }